module.exports = __webpack_public_path__ + "img/printer.8e3e7174.svg";